import { useAdminMe } from "@/features/admin-auth/api/adminAuthApi";
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

interface Props {
  children: ReactNode;
}

export function AdminPublicOnlyRoute({ children }: Props) {
  const { isPending, data } = useAdminMe();

  if (isPending) {
    return (
      <main className="flex min-h-screen items-center justify-center bg-app-bg">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-app-border border-t-app-emerald" />
      </main>
    );
  }

  if (data) {
    return <Navigate to="/admin/access-requests" replace />;
  }

  return <>{children}</>;
}
